module.exports = __webpack_public_path__ + "img/tel.dc1e5d3c.svg";